import { ClientConfig } from 'next-sanity';

// export the projectId, dataset, apiVersion, and other client configurations
export const sanityConfig: ClientConfig = {
  dataset: process.env.NEXT_PUBLIC_SANITY_API_DATASET,
  projectId: process.env.NEXT_PUBLIC_SANITY_API_PROJECT_ID,
  apiVersion: '2021-08-31',
  useCdn: process.env.VALUE_ENV === 'production',
};
